import { UAParser } from "ua-parser-js";

export default () => {
  const { userAgent } = window.navigator;
  const uaParser = new UAParser(userAgent);
  const os = uaParser.getOS();

  return os.name === "Mac OS" || os.name === "iOS";
};
